import moment from "jalali-moment";
import { ReactElement, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import endpoints from "../../../config/endpoints";
import orderEnum from "../../../enums/orderEnum";
import useTicker from "../../../hooks/useTicker";
import { popupSlice } from "../../../services/reducers";
import { setLoading } from "../../../services/reducers/homeSlice";
import restApi from "../../../services/restApi";
import { Sidebar } from "../../../layouts/Sidebar";
import { useAppSelector } from "../../../services/store";
import BuyReport from "./BuyReport";
import StoreDetails from "./StoreDetails";
import Status = orderEnum.Status;

const Buy = () => {
  const [data, setData] = useState<any>();
  const [query, setQuery] = useState("");
  const userReducer = useAppSelector((state) => state.userReducer);
  const [stores, setStores] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const deleteOrder = async (id: number) => {
    if (confirm("آیا مطمئن هستید؟")) {
      dispatch(setLoading(true));

      const res = await restApi(
        process.env.REACT_APP_BASE_URL + "/admin/order/" + id,
        true,
      ).delete({});

      if (res.code == 204) {
        Swal.fire({
          title: "موفق",
          text: "سفارش با موفقیت حذف شد",
          icon: "success",
          confirmButtonText: "متوجه شدم",
        });
      } else {
        Swal.fire({
          title: "ناموفق",
          text: res?.data,
          icon: "error",
          confirmButtonText: "متوجه شدم",
        });
      }

      dispatch(setLoading(false));
    }
  };

  const handleSelect = async (id: number, status: number) => {
    if (confirm("آیا مطمئن هستید؟")) {
      const res = await restApi(
        process.env.REACT_APP_BASE_URL + "/admin/order/status/" + id,
        true,
      ).put({
        status: status,
      });

      if (res.code == 200) {
        Swal.fire({
          title: "موفق",
          text: "وضعیت با موفقیت تغییر کرد",
          icon: "success",
          confirmButtonText: "متوجه شدم",
          didClose() {
            // (status == 3 || status == 6) && dispatch(popupSlice.middle(<BillDetail stores={stores} orderProduct={data.find((e) => e.id == id)}/>))
          },
        });
      } else {
        Swal.fire({
          title: "ناموفق",
          text: res?.data,
          icon: "error",
          confirmButtonText: "متوجه شدم",
        });
      }

      dispatch(setLoading(false));
    }
  };

  const list = () => {
    const rows: ReactElement[] = [];

    data
      ?.filter(
        (e) =>
          e.order?.orderStatusSlug == Status.WaitToBuy &&
          (e.buy?.buyerId == userReducer.profile?.id ||
            userReducer.profile?.roleId == 2) &&
          e.status != 2,
      )
      .map((orderProduct: any, index) => {
        rows.push(
          <tr className="dashTr2" key={"order" + index}>
            <td className="svgContainer">
              <i
                className="edit clickable"
                onClick={() =>
                  orderProduct.store &&
                  dispatch(
                    popupSlice.middle(
                      <StoreDetails store={orderProduct.store} />,
                    ),
                  )
                }
              ></i>
              <i
                className="factorSvg clickable"
                onClick={() =>
                  dispatch(
                    popupSlice.middle(
                      <BuyReport
                        orderProduct={orderProduct}
                        fetchData={fetchData}
                      />,
                    ),
                  )
                }
              ></i>
            </td>
            <td className="">
              {moment(orderProduct?.createdAt).format("jYYYY/jMM/jDD HH:MM")}
            </td>
            <td className="">{orderProduct?.price}</td>
            <td className="">{orderProduct?.store?.title}</td>
            <td className="">{orderProduct?.count}</td>
            <td className="">{`${orderProduct?.attribute?.attributeSpecific?.specific?.title || ""} : ${orderProduct?.attribute?.attributeSpecific?.specificValue?.title || ""}`}</td>
            <td className="">{orderProduct?.product?.part?.title}</td>
            <td className="">{orderProduct?.product?.title}</td>
            <td className="">{orderProduct?.order?.code}</td>
          </tr>,
        );
      });

    return rows;
  };

  const fetchData = async () => {
    dispatch(setLoading(true));

    await Promise.all([
      await restApi(endpoints.orderProduct.index).get(),
      await restApi(endpoints.store.index).get(),
    ]).then((res) => {
      setData(res[0].data);
      setStores(res[1].data);
    });

    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <body className="dashboardBody">
        <Sidebar />
        <main className="dashBoardMain">
          <h1 className="dashBoardTitle">سفارش ها</h1>
          <div className="searchContainer">
            <span className="backSpan keepRight">
              {/*  <span className="dashboardHeader clickable" onClick={() => dispatch(popupSlice.middle(<Excel />))}> */}
              {/*   <p>بارگزاری فایل اکسل</p> */}
              {/*   <i className="exelSvg"></i> */}
              {/* </span> */}
              {/* <span className="dashboardHeader clickable" onClick={() => dispatch(popupSlice.middle(<Derham />))}> */}
              {/*   <p>قیمت روز درهم</p> */}
              {/*   <i className="derhamSvg"></i> */}
              {/* </span> */}
            </span>
            <div className="dashboardseaechBox">
              <i className="dashMagnifierIcon"></i>
              <input
                className="dashSearchInput"
                placeholder="جستجو"
                onChange={(input: any) => setQuery(input.target.value)}
              ></input>
            </div>
          </div>
          <table>
            <thead>
              <tr className="dashTr1 blueText">
                <th>عملیات</th>
                <th>تاریخ</th>
                <th>قیمت</th>
                <th>آدرس فروشگاه</th>
                <th>تعداد</th>
                <th>جزئیات</th>
                <th>نوع کالا</th>
                <th>نام کالا</th>
                <th>شماره سفارش</th>
              </tr>
            </thead>
            {list()}
          </table>
        </main>
      </body>
    </>
  );
};
export default Buy;
